const getParentAndIndexFromTree = (subtree, result, parent = null, index = 0) => {
  if (subtree.id) {
    result[subtree.id] = {
      parent,
      index
    };
  }
  subtree.children.map((childNode, childIndex) => {
    getParentAndIndexFromTree(childNode, result, subtree.id, childIndex);
  });
};

const getParentAndIndexForAllIds = tree => {
  let result = {};
  getParentAndIndexFromTree(tree, result);
  return result;
};

export default getParentAndIndexForAllIds;
